export type InsuranceBaseLimit = { min: number; max: number };
export type HousingFundBaseLimit = { min?: number; max: number };

export type LimitsConfig = {
  version: string;
  updatedAt?: string;
  insuranceBaseLimits: Record<string, InsuranceBaseLimit>;
  housingFundBaseLimits: Record<string, HousingFundBaseLimit>;
  provinceCityMapping: Record<string, string[]>;
};

export const DEFAULT_LIMITS: LimitsConfig = {
  version: 'embedded-2025.0.0',
  updatedAt: '2025-01-01',
  insuranceBaseLimits: {
    Sichuan: { min: 4511, max: 22555 },
  },
  housingFundBaseLimits: {
    Chengdu: { max: 31362 },
  },
  provinceCityMapping: {
    Sichuan: ['Chengdu', 'Mianyang', 'Deyang'],
  },
};

// Fetch yearly limits from a JSON file. Falls back to embedded defaults.
export async function loadLimits(url?: string): Promise<LimitsConfig> {
  if (!url) return DEFAULT_LIMITS;
  try {
    const res = await fetch(url, { cache: 'no-cache' });
    if (!res.ok) throw new Error(`Failed to load limits: ${res.status}`);
    const data = (await res.json()) as LimitsConfig;

    // Minimal runtime validation
    if (!data || typeof data !== 'object') throw new Error('Invalid limits payload');
    if (!data.insuranceBaseLimits || !data.housingFundBaseLimits || !data.provinceCityMapping) {
      throw new Error('Missing limits sections');
    }
    return data;
  } catch {
    return DEFAULT_LIMITS;
  }
}
